import React from "react";
import Banner from "./Banner";
import Security from "./Security";
import Solution from "./Solution";
import Resources from "./Resources";
import Licenses from "./Licenses";
import MetaTags from "react-meta-tags";
import Investor from "./Investor";
import LogoCarousel from "./LogoCarousel";
import Clients from "./Clients";
import structuredData from "./structuredData.json";

function Landing(props) {
  return (
    <>
      <MetaTags>
        <title>
          ESG Software - Sustainability Data Management & Data Reporting
          Software
        </title>
        <meta
          name="description"
          content="Updapt is an ESG and sustainability data management software that includes ESG reporting, net-zero tracking, analysis, climate risk analysis module, and supplier assessment."
        />
        <meta
          property="og:title"
          content="ESG Software - Sustainability Data Management & Data Reporting Software"
        />
        <meta
          property="og:image"
          content="%PUBLIC_URL%/static/media/banner.jpg"
        />
        <script type="application/ld+json" async>
          {JSON.stringify(structuredData)}
        </script>
      </MetaTags>

      <Banner />
      <div className="slider">
        <LogoCarousel />
      </div>
      <Solution />
      <div className="border-line"></div>
      <Security securityDetails={props.securityDetails} />
      <div className="border-line"></div>
      {/* <Pricing pricingPlans={props.pricingPlans} /> */}
      <Investor />
      <Licenses licencingDetails={props.licencingDetails} />
      <Clients
        clientDetails={props.clientDetails}
        handleBackButton={props.handleBackButton}
        index={props.index}
        handleNextButton={props.handleNextButton}
        characterCount={props.characterCount}
        handleReadMore={props.handleReadMore}
        readMoreBool={props.readMoreBool}
      />
      <Resources blogsData={props.blogsData} />
    </>
  );
}

export default Landing;
